import pluralize from 'pluralize';

export const pluralizeWithFormattedNumber = (word: string, number: number) => {
  let pluralizedWord = pluralize(word, number);

  // do not capitalize 's' for SKUs
  if (word === 'SKU') {
    pluralizedWord = 'SKUs';
  }
  const formattedNumber = number.toLocaleString('en-US');
  return `${formattedNumber} ${pluralizedWord}`;
};
